export default __webpack_public_path__ + "static/media/orgValue.e85a1196.svg";